import React, { useEffect, useState } from "react";
import { Button, Col, Collapse, Spin } from "antd";
import { Link } from "react-router-dom";

import jwtDecode from "jwt-decode";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

import { COLORS } from "../../../../constants";
import { initialValue } from "../../../features/panelAdmin/initialValue";
import PanelAdmin from "../../../features/panelAdmin/paneladmin";
import { getAllFAQ, insertFAQ } from "../../../http-request/faq";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 50, color: COLORS.blue1 }} spin />
);

const antIconCreating = (
  <LoadingOutlined style={{ fontSize: 20, color: COLORS.white }} spin />
);

const FAQPanelContainer = () => {
  const token = jwtDecode(localStorage.getItem("token"));
  const userType = token?.loginAs;
  const [faqs, setfaqs] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isCreating, setisCreating] = useState(false);
  const [activeKeys, setActiveKeys] = useState([]);

  const onChange = (keys) => {
    setActiveKeys(keys);
  };

  useEffect(() => {
    loadFAQ();
  }, []);

  const loadFAQ = async () => {
    setisLoading(true);
    await getAllFAQ()
      .then(({ faqs }) => setfaqs(faqs))
      .finally(() => setisLoading(false));
  };

  return (
    <>
      {!isLoading ? (
        <Collapse onChange={onChange} ghost style={{ width: "100%" }}>
          {faqs.map((item, index) => (
            <PanelAdmin
              loadFAQ={loadFAQ}
              index={index}
              header={item.title}
              {...item}
              _activeKeys={activeKeys}
            />
          ))}
        </Collapse>
      ) : (
        <Col span={20}>
          <center>
            <Spin indicator={antIcon} />
          </center>
        </Col>
      )}

      <Col span={10}>
        <Button
          disabled={isCreating}
          onClick={async () => {
            setisCreating(true);
            await insertFAQ(initialValue)
              .then(
                async () => await getAllFAQ().then(({ faqs }) => setfaqs(faqs))
              )
              .finally(() => setisCreating(false));
          }}
          block
          style={{
            backgroundColor: COLORS.orange,
            border: 0,
            marginTop: "20px",
          }}
          icon={
            isCreating ? (
              <Spin indicator={antIconCreating} />
            ) : (
              <PlusOutlined style={{ color: COLORS.white }} />
            )
          }
        />
      </Col>

      <Button
        type="primary"
        block
        style={{
          backgroundColor: "#00BCFB",
          marginTop: "20px",
          minHeight: "55px",
        }}
      >
        <Link
          to={`/v2/${userType}/contacts`}
          state={userType}
          style={{ fontWeight: "bold", fontSize: "larger", color: "inherit" }}
        >
          CONTACT GENSAN TOURISM DEPT.
        </Link>
      </Button>
    </>
  );
};

export default FAQPanelContainer;
